module.exports = __webpack_public_path__ + "img/HE7301-112.e9977a2e.jpg";